import { VexFlow } from 'vexflow';
import '@vexflow-fonts/bravura/index.css';

let fontsReady: Promise<void> | null = null;
let metricsApplied = false;

/** Métricas VexFlow para módulos musicales Edusico Sala. */
export function applySalaVexMetrics(printMode = false): void {
  if (metricsApplied && !printMode) return;
  VexFlow.setFonts('Bravura', 'Bravura Text');
  VexFlow.NOTATION_FONT_SCALE = printMode ? 38 : 42;
  VexFlow.STAVE_LINE_DISTANCE = printMode ? 10 : 11;
  VexFlow.STEM_HEIGHT = printMode ? 32 : 38;
  VexFlow.STAVE_LINE_THICKNESS = 1.25;
  if (!printMode) metricsApplied = true;
}

export function ensureSalaVexFonts(): Promise<void> {
  applySalaVexMetrics(false);
  if (!fontsReady) {
    fontsReady = VexFlow.loadFonts('Bravura', 'Bravura Text').then(() => {
      applySalaVexMetrics(false);
    });
  }
  return fontsReady;
}

export function resetSalaVexMetricsForPrint(): void {
  applySalaVexMetrics(true);
  metricsApplied = false;
}
